// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 780) return "assets/date-range.js";
	if (chunkId === 668) return "assets/forms.js";
	if (chunkId === 368) return "assets/property-card.js";
	if (chunkId === 192) return "assets/search.js";
	if (chunkId === 328) return "assets/select2.js";
	if (chunkId === 832) return "assets/carousel.js";
	if (chunkId === 240) return "assets/steps-section.js";
	if (chunkId === 221) return "assets/pikaday.js";
	// return url for filenames based on template
	return undefined;
};